import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { ExportJobsPagination } from 'packages/candidate_export/entities/ExportJobsPagination';
import { ExportJob } from 'packages/candidate_export/entities/ExportJob';
import { KomboRecruitmentAssociation } from 'packages/candidate_export/entities/KomboRecruitmentAssociation';
export var types = {
    SET_EXPORT_SYSTEMS: 'setExportSystems',
    SET_EXPORT_JOBS: 'setExportJobs',
    SET_SELECTED_EXPORT_JOB: 'setSelectedExportJob',
    SET_SELECTED_RECRUITMENT_ASSOCIATION: 'setSelectedRecruitmentAssociation',
    SET_EXPORT_JOBS_PAGINATION_NEXT_CURSOR: 'setExportJobsPaginationNextCursor',
    SET_EXPORT_JOBS_PAGINATION_CURSOR_STACK: 'setExportJobsPaginationCursorStack',
    RESET_EXPORT_JOBS_PAGINATION: 'resetExportJobsPagination',
    SET_LOADING: 'setLoading',
    SET_CONSENTS: 'setConsents',
};
export var state = {
    selectedExportJob: new ExportJob(),
    selectedRecruitmentAssociation: new KomboRecruitmentAssociation(),
    exportSystems: [],
    exportJobs: [],
    exportJobsPagination: new ExportJobsPagination(),
    loading: false,
    consents: [],
};
export var exportCandidates = {
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions,
};
